/*
 * AdminContent.tsx (AbstractECommerce)
 *
 * Copyright © 2020 InstaLOD GmbH - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * This file and all its contents are proprietary and confidential.
 *
 * Maintained by Martin Witczak, 2020
 *
 * @file AdminContent.tsx
 * @author Martin Witczak
 * @copyright 2020 InstaLOD GmbH. All rights reserved.
 * @section License
 * @modified Rafael Rodrigues - 2022
 */

import React, { useEffect, useState } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getRoutes } from '../../Routes/Routes';
import PageHeader from '@abstract/abstractwebcommon-client/PageHeader/PageHeader';
import Col from 'react-bootstrap/Col';
import { SharedCommomRouteName } from '@abstract/abstractwebcommon-client/utils/sharedRoutesNames';
import { LocalStorage } from '@abstract/abstractwebcommon-client/utils/sharedLocalStorage';
import { LanguageSettingsMode } from '@abstract/abstractwebcommon-shared/interfaces/Language';

const AdminContent = () => {
  const user = useSelector((state) => state.userAuth);
  const languageSettingsMode: string =
    LocalStorage.getLanguageSettingsMode() ||
    LanguageSettingsMode.english; /**< Language settings mode */
  const [routes, setRoutes] = useState<any>([]); /**< Routes */

  // Get admin routes when language changes
  useEffect(() => {
    const adminRoutes = getRoutes();
    setRoutes([...adminRoutes]);
  }, [languageSettingsMode]);

  //Note: Get admin routes when localstorage changes
  window.addEventListener('storage', (event: StorageEvent) => {
    if (event.key === LocalStorage.languageSettingsModeKey) {
      const adminRoutes = getRoutes();
    setRoutes([...adminRoutes]);
    }
  });

  /// Render specific component if isAuthenticated and if isAdmin, Else redirect to login.
  const renderComponent = routes.map(
    ({ path, Component, authenticated, headingKey }, key) => {
      if (authenticated && !user.isAuthenticated && !user.isAdmin) {
        return (
          <Redirect
            key={key}
            to={{ pathname: SharedCommomRouteName.validateRoute }}
          />
        );
      }

      return (
        <Route exact path={path} key={key}>
          {headingKey ? (
            <div className="custom-page-header-container">
              <PageHeader title={headingKey} />
            </div>
          ) : null}
          <Col sm={12}>
            <Component />
          </Col>
        </Route>
      );
    }
  );

  return <Switch>{renderComponent}</Switch>;
};

export default AdminContent;
